/* eslint-disable import/prefer-default-export */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { isEmpty } from 'lodash';
import VerbText from '../../../shared/components/VerbText';
import VerbMenuItem from '../../../shared/components/VerbMenuItem';
import { SEGMENT_EVENTS } from '../../../shared/Constants';
import { RuntimeContext } from '../../../../common/RuntimeContext';

export class NavigationSubMenu extends PureComponent {
    static propTypes = {
        currentProfile: PropTypes.object,
        userCompany: PropTypes.object,
        isAuthenticated: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        isVerbAdmin: PropTypes.bool,
        renderForMobile: PropTypes.bool,
        activeUserTeams: PropTypes.array
    };

    static contextType = RuntimeContext;

    /**
     *
     * @param {Object} params
     * @param {*} ComponentToRender
     * @param {boolean} params.isMobile
     * @return {XML}
     * @private
     */
    _generateSubMenuDivider = (params) => {
        const { key = '', isMobile } = params;

        const componentProps = {
            className: cns({ 'hidden-md hidden-lg': !isMobile }, 'dropdown-divider')
        };

        if (!isEmpty(key)) {
            componentProps.key = key;
        }

        return <div {...componentProps} />;
    };

    /**
     *
     * @param {Object} params
     * @param {*} params.ComponentToRender
     * @param {string} params.itemText
     * @param {string} params.href
     * @param {*} [params.onClickHandler=null]
     * @param {boolean} params.isMobile
     * @return {XML}
     * @private
     */
    _generateSubMenuItem = (params) => {
        const { itemText = '', href, onClickHandler = null, isMobile, className, key, openInNewTab = false } = params;
        let itemToRender;
        const componentProps = {
            key: href,
            className: cns('dropdown-button', className, { 'hidden-md hidden-lg': !isMobile })
        };

        if (href) {
            componentProps.href = href;
        }

        if (key) {
            componentProps.key = key;
        }

        if (onClickHandler) {
            componentProps.onClick = onClickHandler;
        }

        if (openInNewTab) {
            componentProps.target = '_blank';
        }

        if (typeof itemText === 'string') {
            itemToRender = itemText.toLocaleUpperCase();
        } else {
            itemToRender = itemText;
        }

        return (
            <VerbMenuItem {...componentProps}>
                <small className={'navbar-subsection-title'}>{itemToRender}</small>
            </VerbMenuItem>
        );
    };

    /**
     *
     * @param {boolean} [renderForMobile=false]
     * @return {Array}
     * @private
     */
    _buildSubMenu = (renderForMobile = false) => {
        const { currentProfile = {}, userCompany = {}, isAuthenticated, isAccountOwner } = this.props;
        const companyPermalink = userCompany.permalink || '';
        const hasStripeSubscription = userCompany.stripeSubscriptionId;

        const canViewBilling = isAccountOwner && companyPermalink && hasStripeSubscription;
        const menuItems = [];

        const { frameworkId = '', frameworkOverviewAsset = {} } = userCompany;

        const frameworkAsset =
            frameworkId && frameworkOverviewAsset.id && frameworkOverviewAsset.name
                ? userCompany.frameworkOverviewAsset
                : '';

        // if (!isEmpty(currentProfile)) {
        //     menuItems.push(
        //         this._generateSubMenuItem({
        //             itemText: (
        //                 <Fragment>
        //                     {`${currentProfile.firstName} ${currentProfile.lastName}`}
        //                     <br />
        //                     <small className={'navbar-subsection-title nav-email'}>{currentProfile.email}</small>
        //                 </Fragment>
        //             ),
        //             key: `${currentProfile._id}`,
        //             href: `/profile/${currentProfile._id}`,
        //             isMobile: renderForMobile,
        //             className: 'profile-link',
        //         })
        //     );
        //     menuItems.push(
        //         this._generateSubMenuDivider({
        //             key: 'divider1',
        //             isMobile: renderForMobile,
        //             className: 'dropdown-divider'
        //         })
        //     );
        //     menuItems.push(
        //         this._generateSubMenuItem({
        //             itemText: <VerbText messageId={'HEADER_MY_PROFILE'} defaultMessage={'MY PROFILE'} />,
        //             href: `/profile/${currentProfile._id}`,
        //             isMobile: renderForMobile,
        //             className: 'profile-link',
        //         })
        //     );
        //     menuItems.push(
        //         this._generateSubMenuItem({
        //             itemText: <VerbText messageId={'HEADER_MY_SETTINGS'} defaultMessage={'MY SETTINGS'} />,
        //             href: `/profile/${currentProfile._id}/settings`,
        //             isMobile: renderForMobile,
        //             className: 'profile-link',
        //         })
        //     );
        // }

        if (canViewBilling) {
            menuItems.push(
                this._generateSubMenuItem({
                    itemText: <VerbText messageId={'HEADER_BILLING'} defaultMessage={'BILLING'} />,
                    href: `/account/${companyPermalink}/history`,
                    isMobile: renderForMobile,
                    className: 'billing-link'
                })
            );
        }

        if (renderForMobile && menuItems.length) {
            menuItems.push(
                this._generateSubMenuDivider({
                    key: 'divider2',
                    isMobile: renderForMobile,
                    className: 'dropdown-divider'
                })
            );
        }
        if (frameworkAsset) {
            menuItems.push(
                this._generateSubMenuItem({
                    itemText: (
                        <VerbText
                            messageId={frameworkAsset.name.toUpperCase()}
                            defaultMessage={frameworkAsset.name.toUpperCase()}
                        />
                    ),
                    href: `/assetlink/${frameworkAsset.id}`,
                    isMobile: renderForMobile,
                    className: 'faq-link',
                    openInNewTab: true
                })
            );
        }

        if (
            userCompany.lmsIntegrations &&
            userCompany.lmsIntegrations.lmsNavigation &&
            userCompany.lmsIntegrations.lmsNavigation.lmsLabel &&
            userCompany.lmsIntegrations.lmsNavigation.lmsLink
        ) {
            const href =
                userCompany.lmsIntegrations.lmsNavigation.lmsLink.indexOf('http://') === 0 ||
                userCompany.lmsIntegrations.lmsNavigation.lmsLink.indexOf('https://') === 0
                    ? userCompany.lmsIntegrations.lmsNavigation.lmsLink
                    : `http://${userCompany.lmsIntegrations.lmsNavigation.lmsLink}`;

            menuItems.push(
                this._generateSubMenuItem({
                    itemText: (
                        <VerbText
                            messageId={'NAVIGATION_LMSLink'}
                            defaultMessage={userCompany.lmsIntegrations.lmsNavigation.lmsLabel.toUpperCase()}
                        />
                    ),
                    href,
                    isMobile: renderForMobile,
                    className: 'lms-link',
                    openInNewTab: true
                })
            );
        }

        if (renderForMobile) {
            menuItems.push(
                this._generateSubMenuDivider({
                    key: 'divider3',
                    isMobile: renderForMobile,
                    className: 'dropdown-divider'
                })
            );
        }

        return menuItems;
    };

    render() {
        const { renderForMobile } = this.props;

        return <Fragment>{this._buildSubMenu(renderForMobile)}</Fragment>;
    }
}
